<template>
  <div class="v-stack h-stretch gap-3">
    <div class="h-stack h-end">
      <button
        v-if="$store.state.accessLevel > 8"
        @click="$router.push('/users/customers/add')"
        class="add"
      >
        New
      </button>
    </div>
    <Table
      :loading="loading"
      :items="customers"
      :defaultColumn="0"
      css="200px 200px 100px 1fr 80px 1fr"
      v-on:rowSelected="$router.push('/users/detail/' + $event._id)"
      :columns="[
        {
          name: 'Name',
          sort: 'alphabet',
          path: ['fullName'],
        },
        {
          name: 'Company',
          sort: 'alphabet',
          path: ['client', 'name'],
        },
        {
          name: 'Phone',
          sort: 'numeric',
          path: ['phoneNumber'],
          formatType: 'phone',
        },
        {
          name: 'Email',
          sort: 'alphabet',
          path: ['email'],
        },
      ]"
    ></Table>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Table from "@/components/Table.vue";

export default {
  data() {
    return {
      customers: [],
      loading: true,
    };
  },
  components: {
    Table,
  },
  methods: {
    ...mapActions(["getCustomers"]),
    refresh() {
      this.loading = true;
      this.getCustomers()
        .then((customers) => {
          this.customers = customers;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>
